var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 44,
    viewBox: "0 0 51 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22C0 21.1712 0.329241 20.3763 0.915292 19.7903C1.50134 19.2042 2.2962 18.875 3.125 18.875H39.3313L25.9125 5.46248C25.3257 4.87569 24.9961 4.07983 24.9961 3.24998C24.9961 2.42013 25.3257 1.62427 25.9125 1.03748C26.4993 0.450689 27.2952 0.121033 28.125 0.121033C28.9548 0.121033 29.7507 0.450689 30.3375 1.03748L49.0875 19.7875C49.3785 20.0778 49.6094 20.4226 49.767 20.8023C49.9245 21.1819 50.0056 21.5889 50.0056 22C50.0056 22.411 49.9245 22.818 49.767 23.1977C49.6094 23.5773 49.3785 23.9222 49.0875 24.2125L30.3375 42.9625C29.7507 43.5493 28.9548 43.8789 28.125 43.8789C27.2952 43.8789 26.4993 43.5493 25.9125 42.9625C25.3257 42.3757 24.9961 41.5798 24.9961 40.75C24.9961 39.9201 25.3257 39.1243 25.9125 38.5375L39.3313 25.125H3.125C2.2962 25.125 1.50134 24.7957 0.915292 24.2097C0.329241 23.6236 0 22.8288 0 22Z",
    fill: "#B1C65C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGreen);
export default __webpack_public_path__ + "static/media/arrow-right-green.ada36b2ede8cf4c8b181717c9636f80a.svg";
export { ForwardRef as ReactComponent };